import React from 'react';

import { format, startOfMonth } from 'date-fns';
import PropTypes from 'prop-types';

import Button from '@asteria/component-core/button';

import Chip from '@asteria/component-chip/chip';
import Datepicker from '@asteria/component-form/datepicker';
import Input from '@asteria/component-form/input';

import { useTranslate } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import ClientSelector from '../../../../../selector/client';
import CurrencySelector from '../../../../../selector/currency';
import TagSelector from '../../../../../selector/tag';

import '../../../../styles.scss';

const TransactionItemView = React.memo((props) => {
	const {
		className,
		style,
		showTags,
		type,
		inputConfig,
		placeholder,
		showCategory,
		InputFormat,
		handleRemove,
		handleCopy,
		currencySelectorRef,
		analytics,
	} = props;
	const { t } = useTranslate();
	return (
		<div
			className={cn(
				'asteria-component__forecaster-transactions-list-item',
				className,
			)}
			style={style}
		>
			{showTags ? (
				<Chip
					variant="simple"
					colors={type}
					label={t(`forecaster.transactions.item.type.${type}`)}
				/>
			) : null}
			{showCategory ? (
				<div
					className={cn(
						'asteria-component__forecaster-transactions-list-cell',
						'asteria--type-categories',
					)}
				>
					<TagSelector
						variant="select"
						type={type.toLowerCase()}
						showProbability
						name={`payload.tags`}
					/>
				</div>
			) : null}
			<div
				className={cn(
					'asteria-component__forecaster-transactions-list-cell',
					'asteria--type-description',
				)}
			>
				{!inputConfig ? (
					<Input
						placeholder={placeholder}
						name={`payload.description`}
					/>
				) : (
					<ClientSelector
						dataSource={inputConfig.dataSource}
						filters={inputConfig.filters}
						name={`$extra.${inputConfig.name}`}
						showSelectedIcon
						showEdit
						showAdd
					/>
				)}
			</div>
			<div
				className={cn(
					'asteria-component__forecaster-transactions-list-cell',
					'asteria--type-date',
				)}
			>
				<Datepicker
					isPastDisabled
					name={`payload.paymentDate`}
					iconPosition="first"
					startDate={format(startOfMonth(new Date()), 'yyyy-MM-dd')}
					// endDate={format(endOfMonth(new Date(date)), 'yyyy-MM-dd')}
					tooltip={t(
						['forecaster.transactions.datepicker.tooltip'],
						// eslint-disable-next-line spellcheck/spell-checker
						{ default: 'Klicka för att välja datum' },
					)}
				/>
			</div>
			<div
				className={cn(
					'asteria-component__forecaster-transactions-list-cell',
					'asteria--type-currency',
				)}
			>
				<CurrencySelector
					ref={currencySelectorRef}
					name={`payload.currency`}
				/>
			</div>
			<div
				className={cn(
					'asteria-component__forecaster-transactions-list-cell',
					'asteria--type-total',
				)}
			>
				<Input
					format={InputFormat}
					name={`payload.total`}
					type="number"
					debounce={500}
				/>
			</div>
			<div
				className={cn(
					'asteria-component__forecaster-transactions-list-cell',
					'asteria--type-actions',
				)}
			>
				<Button
					icon="clipboard"
					onClick={handleCopy}
					tooltip={t(
						['forecaster.transactions.copy.tooltip'],
						// eslint-disable-next-line spellcheck/spell-checker
						{ default: 'Klicka för att kopiera till nästa månad' },
					)}
					analyticsKey="forecaster.transactions.copy"
					analytics={analytics}
				/>
				<Button
					icon="remove"
					onClick={handleRemove}
					tooltip={t(
						['forecaster.transactions.remove.tooltip'],
						// eslint-disable-next-line spellcheck/spell-checker
						{ default: 'Klicka för att ta bort transaktion' },
					)}
					analyticsKey="forecaster.transactions.remove"
					analytics={analytics}
				/>
			</div>
		</div>
	);
});

TransactionItemView.displayName = 'TransactionItemView';

TransactionItemView.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string,
	style: PropTypes.object,
	types: PropTypes.arrayOf(PropTypes.string),
	type: PropTypes.string,
	inputConfig: PropTypes.object,
	placeholder: PropTypes.string,
	showCategory: PropTypes.bool,
	handleChange: PropTypes.func,
	handleRemove: PropTypes.func,
	InputFormat: PropTypes.object,
	currencySelectorRef: PropTypes.node,
	analytics: PropTypes.object,
	handleCopy: PropTypes.func,
};

export default TransactionItemView;
